module.exports = __webpack_public_path__ + "static/media/document.b0f53ab2.svg";